<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/placement/${inputs.id}`
						: `transaction/placement`
				"
			>
				<!-- Assigned Date -->
				<div class="form-group row align-items-center">
					<label for="input_assigned_at" class="col-sm-3 mb-0">
						Assigned Date
					</label>
					<app-input
						id="input_assigned_at"
						class="col-sm-9"
						type="date"
						v-model="inputs.assigned_at"
						placeholder="Assigned Date"
						required
						:disabled="this.selectedUrl ? true : false"
					/>
				</div>
				<!-- Product Name -->
				<div class="form-group row align-items-center">
					<label for="inputs_product_id" class="col-sm-3 mb-0">
						Product Name
					</label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product_id"
						@input="setProductIdValue"
						fetch-url="master/product?is_active=true&product_category=1&per_page=50"
						placeholder="Product Name"
						list-value-field="name"
						required
					/>
				</div>
				<!-- Placement Type -->
				<div class="form-group row align-items-center">
					<label for="inputs_placement_type" class="col-sm-3 mb-0">
						Placement Type
					</label>
					<app-input
						id="inputs_placement_type"
						class="col-sm-9"
						type="search-select"
						:list="placementTypeLists"
						v-model="inputs.placement_type"
						placeholder="Placement Type"
						required
						disabled
					/>
				</div>
				<!-- Assigned By -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_assigned_by" class="col-sm-3 mb-0">
						Assigned By
					</label>
					<app-input
						id="inputs_assigned_by"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.assigned_by"
						placeholder="Assigned By"
						:list="assignedByLists"
						required
					/>
				</div> -->
				<!-- Booked Date -->
				<div class="form-group row align-items-center">
					<label for="inputs_booked_date" class="col-sm-3 mb-0">
						Booked Date
					</label>
					<app-input
						id="inputs_booked_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.booked_date"
						placeholder="Booked Date"
						required
					/>
				</div>
				<!-- Booked Time -->
				<div class="form-group row align-items-center">
					<label for="inputs_booked_time" class="col-sm-3 mb-0">
						Booked Time
					</label>
					<app-input
						id="inputs_booked_time"
						class="col-sm-9"
						type="time"
						v-model="inputs.booked_time"
						placeholder="Booked Time"
					/>
				</div>
				<!-- Completed By -->
				<div
					class="form-group row align-items-center"
					v-if="modalTitle == this.$t('edit')"
				>
					<label for="inputs_completed_by" class="col-sm-3 mb-0">
						Completed By
					</label>
					<app-input
						id="inputs_completed_by"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.completed_by"
						placeholder="Completed By"
						:list="completedByLists"
						@input="setCompletedByValue"
						:required="true"
					/>
				</div>
				<!-- Completed Date -->
				<div
					class="form-group row align-items-center"
					v-if="modalTitle == this.$t('edit')"
				>
					<label for="inputs_completed_date" class="col-sm-3 mb-0">
						Completed Date
					</label>
					<app-input
						id="inputs_completed_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.completed_date"
						placeholder="Completed Date"
						:required="true"
					/>
				</div>
				<!-- Completed Time -->
				<div
					class="form-group row align-items-center"
					v-if="modalTitle == this.$t('edit')"
				>
					<label for="inputs_completed_time" class="col-sm-3 mb-0">
						Completed Time
					</label>
					<app-input
						id="inputs_completed_time"
						class="col-sm-9"
						type="time"
						v-model="inputs.completed_time"
						placeholder="Completed Time"
						:required="true"
					/>
				</div>
				<!-- Sub Status -->
				<div class="form-group row align-items-center">
					<label for="inputs_sub_status" class="col-sm-3 mb-0">
						Sub Status
					</label>
					<app-input
						id="inputs_sub_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_sub_status"
						@input="setSubStatusValue"
						:fetch-url="`/master/lead-status?lead_status_id=3&per_page=50`"
						:placeholder="'Sub Status'"
						list-value-field="status"
					/>
				</div>
				<!-- Reference Type -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_reference_type" class="col-sm-3 mb-0">
						Reference Type
					</label>
					<app-input
						id="inputs_reference_type"
						class="col-sm-9"
						type="text"
						v-model="inputs.reference_type"
						placeholder="Reference Type"
						required
					/>
				</div> -->
				<!-- Center -->
				<div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						Center
					</label>
					<app-input
						id="inputs_center_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.center_id"
						placeholder="Center"
						:list="centerLists"
						required
					/>
				</div>
				<!-- Notes -->
				<div class="form-group row align-items-center">
					<label for="inputs_notes" class="col-sm-3 mb-0">
						Notes
					</label>
					<app-input
						id="inputs_notes"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.notes"
						:placeholder="'Notes'"
					/>
				</div>
				<!-- Class -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_class_id" class="col-sm-3 mb-0">
						Class
					</label>
					<app-input
						id="inputs_class_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.class_id"
						placeholder="Class"
						:list="classLists"
						required
					/>
				</div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { PlacementBookingFormMixin } from "./PlacementBookingFormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";
import { UserMixin } from "../../../../../Auth/Mixins/UserMixin";

export default {
	name: "PlacementBookingTableForm",
	mixins: [PlacementBookingFormMixin, ModalMixin, UserMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				clc_id_number: this.value.clc_id_number,
				sub_status: this.value?.sub_status?.id || 0,
			},
			input_product_id: this.value
				? this.value.product
					? {
							id: this.value.product.id || 0,
							name: this.value.product.name || "",
							code: this.value.product.code,
							is_active: this.value.product.is_active,
					  }
					: {
							id: this.value.product?.id || 0,
							name: this.value.product?.name || "",
							code: this.value.product?.code,
							is_active: this.value.product?.is_active,
					  }
				: {
						id: this.value.product.id || 0,
						name: this.value.product.name || "",
						code: this.value.product.code,
						is_active: this.value.product.is_active,
				  },
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			subStatusLists: [],
			assignedByLists: [],
			completedByLists: [],
			centerLists: [],
			classLists: [],
			placementTypeLists: [
				{ id: 1, value: "Class Trial" },
				{ id: 2, value: "Placement Test" },
				{ id: 3, value: "Direct Placement" },
			],
			input_sub_status: this.value
				? this.value.sub_status
					? {
							id: this.value.sub_status.id || 0,
							status: this.value.sub_status.status || "",
					  }
					: {
							id: this.value.sub_status?.id || 0,
							status: this.value.sub_status?.status || "",
					  }
				: {
						id: this.value.sub_status.id || 0,
						status: this.value.sub_status.status || "",
				  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		} else {
			this.inputs.completed_by = this.user.loggedInUser.id;
		}
		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [
					subStatusResponse,
					userResponse,
					centerResponse,
					classResponse,
				] = await Promise.all([
					axios.get(
						"/master/lead-status?lead_status_id=3&per_page=100"
					),
					axios.get("/user-list"),
					axios.get("/master/center"),
					axios.get("/transaction/course"),
				]);

				subStatusResponse.data.data.forEach((item) => {
					this.subStatusLists.push({
						id: item.id,
						value: item.status,
					});
					if (
						item.status == "Waiting for Placement" &&
						!this.selectedUrl
					) {
						this.inputs.sub_status = item.id;
					}
				});

				userResponse.data.data.forEach((item) => {
					this.assignedByLists.push({
						id: item.id,
						value: item.full_name
							? item.full_name
							: item.first_name + " " + item.last_name,
					});
					this.completedByLists.push({
						id: item.id,
						value: item.full_name
							? item.full_name
							: item.first_name + " " + item.last_name,
					});
				});

				centerResponse.data.data.forEach((item) => {
					this.centerLists.push({
						id: item.id,
						value: item.name,
					});
				});

				classResponse.data.data.forEach((item) => {
					this.classLists.push({
						id: item.id,
						value: item.course_name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			if (this.inputs.completed_date == null) {
				this.inputs.completed_date = new Date()
					.toISOString()
					.slice(0, 10);
			}
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
			this.inputs = {};
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.input_sub_status = {
				id: this.inputs.sub_status?.id || 0,
				status: this.inputs.sub_status?.status || "",
			};
			this.inputs.placement_type = response.data.placement_type.id;
			// this.inputs.assigned_by = response.data.assigned_by.id
			this.inputs.completed_by = response.data.completed_by?.id;
			this.inputs.sub_status = response.data.sub_status.id;
			this.inputs.product_id = response.data.product_id.id;
			this.inputs.booked_time = response.data.booked_time.slice(0, -3);
			this.inputs.completed_time = response.data.completed_time?.slice(
				0,
				-3
			);

			this.preloader = false;
		},
		setProductIdValue(data) {
			this.inputs.product_id = this.inputs.product_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_id = data.id;
			}
			if (data.id == 42 || data.name.includes("Test")) {
				this.inputs.placement_type = 2;
			} else if (data.id == 43 || data.name.includes("Class")) {
				this.inputs.placement_type = 1;
			} else if (data.id == 44 || data.name.includes("Direct")) {
				this.inputs.placement_type = 3;
			}
		},
		setCompletedByValue(data) {
			this.inputs.completed_date = "";
			this.inputs.completed_time = "";

			let currentDate = new Date(); // Get the current date and time in local timezone
			let jakartaTime = new Date(
				currentDate.toLocaleString("en-US", {
					timeZone: "Asia/Jakarta",
				})
			);

			// Extract date and time separately
			let completedDate = jakartaTime.toISOString().slice(0, 10); // Date in YYYY-MM-DD format

			// Get hours and minutes separately
			let hours = ("0" + jakartaTime.getHours()).slice(-2); // Hours in 2-digit format
			let minutes = ("0" + jakartaTime.getMinutes()).slice(-2); // Minutes in 2-digit format

			let completedTime = `${hours}:${minutes}`; // Form the time as HH:MM

			this.inputs.completed_date = completedDate; // Store the date
			this.inputs.completed_time = completedTime; // Store the time in 24-hour format
		},
		setSubStatusValue(data) {
			this.inputs.sub_status = this.inputs.sub_status;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.sub_status = data.id;
			}
		},
	},
};
</script>
